import React from 'react';

import './style.sass';
import FullWrapper from '../../../../../../core/FullWrapper';
interface TargetProps {
    title: string;
    description: string;
}
export default function Target({ title, description }: TargetProps) {
    return (
        <div className="aimed-target">
            <FullWrapper>
                <div className="aimed-targetWrapper">
                    <div
                        className="aimed-targetLeft"
                        dangerouslySetInnerHTML={{ __html: title }}
                    ></div>
                    <div
                        className="aimed-targetRight"
                        dangerouslySetInnerHTML={{ __html: description }}
                    ></div>
                </div>
            </FullWrapper>
        </div>
    );
}
